/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CurrencyPaginationResponseDto,
  ErrorResponse,
} from '../models/index';
import {
    CurrencyPaginationResponseDtoFromJSON,
    CurrencyPaginationResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface FilterCurrenciesRequest {
    searchText?: string;
    page?: number;
    pageSize?: number;
}

/**
 * 
 */
export class CurrencyApi extends runtime.BaseAPI {

    /**
     * Filter currencies with latest rate
     */
    async filterCurrenciesRaw(requestParameters: FilterCurrenciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CurrencyPaginationResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/currency/filter`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CurrencyPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter currencies with latest rate
     */
    async filterCurrencies(requestParameters: FilterCurrenciesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CurrencyPaginationResponseDto> {
        const response = await this.filterCurrenciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
